var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScienceTechnologySociety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.88,144.69a59.59,59.59,0,1,1,21-45.41c0,1.45,0,2.89-.16,4.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.42,52.4a11.1,11.1,0,0,1,.4,9c-1.89,5.09,3,10,11.86,11.55,6,1.08,3,12.84,3,12.84S60.61,90.23,59.66,98,73.2,113,73.2,113s8,4.42,5.6,11.38c0,0-5.6,20,5.83,22.16,5.15.48-1.77-12.66,6.64-18.76,0,0,4.76-5.39,4-9.48a16.92,16.92,0,0,1-.08-6.72s17.64-15-8.07-21.18C72.45,86.87,81,74.8,85,73.83c13.13-3.23,8.77,6.53,11.37,7.57,14,2.07,1.26-8.87,10.39-13.46,7-3.53,1.76-11.13,5.5-12.73,0,0,6.59-3.25,3.6-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.19,92.21v13.21l2,.55A27.9,27.9,0,0,1,168,108.7l1.82,1,9.08-9.09,7.33,7.32-9,9,1.09,1.83a28.42,28.42,0,0,1,3,7.06l.56,2h12.23v10.36H182l-.52,2.08a27.92,27.92,0,0,1-3.07,7.43l-1.07,1.83,8.31,8.33-7.32,7.32L170,156.88l-1.83,1a28,28,0,0,1-7.59,3l-2.11.51v11.71H148.08v-12l-2-.57a28.38,28.38,0,0,1-7.25-3.29L137,156.12l-8.57,8.58-7.33-7.32L130,148.5l-1-1.79a27.43,27.43,0,0,1-2.63-7.09l-.49-2.14H113.16V127.13h13.11l.59-1.95a28.26,28.26,0,0,1,3-6.56l1.12-1.83-9.32-9.34,7.33-7.33,9.48,9.48,1.81-1a28,28,0,0,1,6.55-2.62l2.05-.54V92.21Zm-5.55,27.37a13.1,13.1,0,1,0,13.1,13.09A13.11,13.11,0,0,0,153.64,119.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceTechnologySociety);
export default __webpack_public_path__ + "static/media/SCIENCE_TECHNOLOGY_SOCIETY.953a8c19a4df2ef51779b0d6a599d934.svg";
export { ForwardRef as ReactComponent };